import { render } from "./CompanyHome.vue?vue&type=template&id=8dc857f6&scoped=true"
import script from "./CompanyHome.vue?vue&type=script&lang=js"
export * from "./CompanyHome.vue?vue&type=script&lang=js"

import "./CompanyHome.vue?vue&type=style&index=0&id=8dc857f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dc857f6"]])

export default __exports__